/**
 * Configure the generated openapi-ts client.
 *
 * Import this module once (e.g. in main.tsx) to set the base URL
 * and register the auth interceptor. The generated SDK functions
 * and TanStack Query hooks will then use these settings automatically.
 */

import { client } from './generated/client.gen';
import { API_BASE } from '../config';
import { attachAuthInterceptors } from './attachAuthInterceptors';

client.setConfig({ baseUrl: API_BASE, credentials: 'include' });
attachAuthInterceptors(client);

export { client };
